import axios from "axios";
import _ from "lodash";
import { getUrl } from "@/common/config";

const convertDataToCloudPlugsStyle = (channel, machineId, responseData) => {
  if (!Array.isArray(responseData.result)) {
    responseData.result = [responseData.result];
  }

  return {
    channel,
    of: machineId,
    at: "",
    id: "",
    action: "data",
    data: responseData.result.map(data => {
      // if (isSpindleSensorChannel(channel))
      //   return { data :
      //             {
      //               v: data.value,
      //               ts: data.timestamp,
      //               meta: {at: data.timestamp, ttl: ''}
      //             }
      //   };
      return {
        v: data.value,
        ts: data.timestamp,
        unit: data.unit,
        meta: { at: data.timestamp, ttl: "" }
      };
    })
  };
};

const convertChannelWildcard = channelWildcard => _.replace(channelWildcard, /\/\+/g, "");

const isAnInfoChannel = channel => {
  const infoChannels = [
    "Machine/Axes/[0-9]+/Type",
    "Machine/Axes/[0-9]+/Role",
    "Machine/OperatingGroups/[0-9]+/Type",
    "Machine/OperatingGroups/[0-9]+/Model",
    "Machine/OperatingGroups/[0-9]+/Location",
    "Machine/OperatingGroups/[0-9]+/Subgroups/[0-9]+/Type",
    "Machine/OperatingGroups/[0-9]+/Subgroups/[0-9]+/Name",
    "Machine/OperatingGroups/[0-9]+/Subgroups/[0-9]+/Location",
    "Machine/AuxiliaryGroups/[0-9]+/Type",
    "Machine/AuxiliaryGroups/[0-9]+/Model",
    "Machine/DataModel",
    "Machine/Model",
    "Machine/Serial",
    "Machine/Type",
    "Machine/Cnc/Name",
    "Machine/Hmi/Name",
    "Machine/Hmi/SharedFolder",
    "Machine/Plc/Version",
    "Machine/Hmi/Version",
    "Machine/Cnc/Version"
  ];

  return new RegExp(infoChannels.join("|")).test(channel);
};

// const isSpindleSensorChannel = channel => {
//   const infoChannels = ["Machine/Spindle/Realtime/[A-Z|a-z]+"];

//   return new RegExp(infoChannels.join("|")).test(channel);
// };

const urlForData = (baseUrl, machineId, channel) => {
  const endpointName = isAnInfoChannel(channel) ? "info" : "messages";
  return `${baseUrl}/machines/${machineId}/${endpointName}/${encodeURIComponent(channel)}`;
};

class MachineMessageStoreApi {
  constructor() {
    this.url = getUrl();
  }

  async getChannels(machineId, channelWildcard) {
    channelWildcard = convertChannelWildcard(channelWildcard);
    return axios
      .get(`${this.url}/api/machines/${machineId}/channels/${encodeURIComponent(channelWildcard)}`)
      .then(response => _.get(response, "data.result", []))
      .catch(() => []);
  }

  async getData(machineId, channel, params, cloudPlugsStyle = true) {
    const request = axios.get(urlForData(`${this.url}/api`, machineId, channel), {
      params
    });

    if (cloudPlugsStyle) {
      return request
        .then(response => convertDataToCloudPlugsStyle(channel, machineId, response.data))
        .catch(() => convertDataToCloudPlugsStyle(channel, machineId, { result: [] }));
    } else {
      return request;
    }
  }

  async getLogsData(machineId, params) {
    return axios.get(`${this.url}/api/machines/${machineId}/logs`, {
      params
    });
  }

  async getItems(machineId, channel, params = {}, all = true, items = []) {
    try {
      const response = await this.getLogsData(machineId, params);

      const { skip, limit } = params;
      const page = skip / (limit || 1);
      const responseData = response && response.data;
      const total = (responseData && responseData.total) || 0;

      items.push(...((responseData && responseData.result) || []));

      if (all && total > items.length) {
        items = await this.getItems(
          machineId,
          channel,
          { ...params, skip: (page + 1) * limit },
          all,
          items
        );
      }
    } catch (e) {
      console.error("[Error] Get raw data error:", e);
      items = [];
    }

    return items;
  }

  async getAllItems(machineId, channel, params) {
    let items = undefined;

    try {
      items = await this.getItems(machineId, channel, { ...params, skip: 0, limit: 100 }, true);
      items = items || [];
    } catch (e) {
      console.error("[Error] Get all items error:", e);
    }

    return items;
  }
}

export const machineMessageStoreApi = new MachineMessageStoreApi();
